var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.labelMargin},[_vm._t("default"),(_vm.markRequired)?_c('span',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }